<template>
  <div class="form-wrapper zj-emergency-add-contact zj-emergency-realtimecall">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            添加连线人
            <button type="button" aria-label="Close" class="el-dialog-close-btn" @click="onBack">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="手机号" prop="PhoneList">
          <div
            :style="{ margin: '3px 0px'}"
            v-for="(item,index) in ruleform.PhoneList"
            :key="index"
          >
            <el-input :style="inlineItemStyle50" v-model="item.Phone"></el-input>
            <el-button
              :style="{'color':'#0294e0','background-color':'transparent'}"
              @click="call(index)"
            >视频连线</el-button>
          </div>
          <div class="zj-emergency-add-contact-btn" @click="addContact()">+ 添加手机号</div>
        </el-form-item>
        <div :style="{'text-align':'end'}">
          <el-button
            class="batch-start-call"
            :style="{'color':'#0294e0','background-color':'transparent'}"
            @click="batchCall()"
          >视频连线</el-button>
        </div>
        <el-form-item label=" ">
          <UserTabControl ref="userTabls" />
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
import UserTabControl from "../../Plan/UserTabControl";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentAddContact",
  componentName: "ZJEmergencyComponentAddContact",
  components: {
    UserTabControl,
  },
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String
    },
    pwd: {
      type: String
    },
    tableData: {
      type: Object,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      personOrgianiztionType: [], // 人员类型
      activeTab: "",
      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem",
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem",
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem",
      },
      isshow: false,
      ruleform: {
        PhoneList: [{ Phone: "" }],
      },
      rules: {
        PhoneList: [
          {
            type: "array",
            validator: this.validphone,
            trigger: "blur",
          },
        ],
      },
      msgkey: {
        emergencyVideoCallKey: "MessageKey_EmergencyVideoCall",
      },
    };
  },
  methods: {
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value || value.length == 0) {
        callback(new Error("请输入电话号码"));
      } else if (!this.validphonelist(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validphonelist(arr) {
      var result = arr.every(function (item) {
        return ZJApp.ZJUtils.isRightMobileNum(item.Phone);
      });
      return result;
    },
    addContact() {
      this.ruleform.PhoneList.push({ Phone: "" });
    },
    removeContact(index) {
      if (this.ruleform.PhoneList.length > 1) {
        this.ruleform.PhoneList.splice(index, 1);
      }
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    getOrgId: function () {
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";
      return deptId;
    },
    getUserIds() {
      let userids = [];
      var chil = this.$refs["userTabls"];
      if (chil && chil.GetOrgUserIds ) {
        userids = chil.GetOrgUserIds();
      }
      return userids;
    },
    getUserItems() {
      let userItems = [];
      var chil = this.$refs["userTabls"];
      if (chil &&  chil.GetCheckedUserItems) {
        userItems = chil.GetCheckedUserItems();
      }
      return userItems;
    },
    call: function (index) {
      if (this.ruleform.PhoneList.length >= 1) {
        var phone = this.ruleform.PhoneList[index];
        if (phone && phone.Phone) {
          this.startCall("", phone.Phone);
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    startCall: function (name, phone) {
      //发送启动视频通话的消息，服务后台发送视频通话链接给联系人
      this.$notify.broadcase({
        key: this.msgkey.emergencyVideoCallKey,
        data: {
          Name: name,
          Phone: phone,
          ExecutId: this.ExecutId,
          RoomId: this.roomId,
          Pwd: this.pwd,
          Content: "您接收到一条视频通话请求！",
        },
      });

      //发送加入房间请求给主页面
      this.dispatch("ZjEmergencyOperations", "onJoinRoomRequestReceived", {
        Name: name,
        Phone: phone,
      });
    },
    batchCall:function() {
      // eslint-disable-next-line no-unused-vars
      let that = this;
      var result = this.getUserItems() || [];
      result.forEach(function(item){
        if (item && item.PhoneNum) {
          that.startCall(item.PersonName, item.PhoneNum);
        }
      });
    }
  },
  created: function () {
    let that = this;
    this.config
      .getUValue("EmergencyService:PersonOrgianiztionType:", "")
      .then((d) => {
        if (d.JValue && d.JValue.length > 0) {
          that.personOrgianiztionType = d.JValue;
          that.activeTab = d.JValue[0].ItemKey;

          //that.loadOrg(that.activeTab);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  },
};
</script>